// [FORGOT-PASSWORD FEATURE - DEMO] whole file - safe to delete to roll back
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { forgotPassword } from "../services/api";

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

/* Pull the most useful message out of a DRF error response */
function extractError(err) {
  const data = err.response?.data;
  if (!data) return "Could not reach the server. Please try again.";
  if (typeof data === "string") return "Something went wrong. Please try again.";
  const first =
    data.username?.[0] ||
    data.email?.[0] ||
    data.non_field_errors?.[0] ||
    data.detail;
  return first || "Could not submit your request. Please try again.";
}

export default function ForgotPasswordModal({ onClose }) {
  const [form, setForm] = useState({ username: "", email: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && !saving && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, saving]);

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await forgotPassword(form);
      setDone(true);
    } catch (err) {
      setError(extractError(err));
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="modal-backdrop" onClick={() => !saving && onClose()}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label="Forgot password"
        style={{ maxWidth: 380, textAlign: "left" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose} disabled={saving} aria-label="Close">
          <CloseIcon />
        </button>
        <div className="modal-title" style={{ marginBottom: 16 }}>Forgot Password</div>

        {done ? (
          <div>
            <p style={{ color: "#16A34A", marginBottom: 16, fontSize: 14 }}>
              Your request has been sent to the admin. You'll receive your new
              password by email shortly.
            </p>
            <button className="btn btn-secondary" style={{ width: "100%" }} onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 16 }}>
              Enter your username and company email. The admin will be
              notified and will send your new password to that email.
            </p>
            <div className="form-group">
              <label className="form-label">myG ID</label>
              <input
                className="form-input"
                value={form.username}
                onChange={update("username")}
                autoFocus
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Company Email</label>
              <input
                type="email"
                className="form-input"
                value={form.email}
                onChange={update("email")}
                required
              />
            </div>

            {error && <div className="error-text">{error}</div>}

            <button className="btn btn-primary" style={{ width: "100%", marginTop: 8 }} disabled={saving}>
              {saving ? "Submitting..." : "Submit Request"}
            </button>
          </form>
        )}
      </div>
    </div>,
    document.body
  );
}
